import React from "react";
import ReactDOM from "react-dom/client";
import "./css/index.less";
import App from "./App";
// import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from "react-router-dom";
import { ConfigProvider, theme, App as AntdApp } from "antd";
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

dayjs.locale('zh-cn');

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router basename={process.env.PUBLIC_URL}>
    <ConfigProvider theme={{
      // algorithm: theme.darkAlgorithm,
      // token: {
      //   colorPrimary: '#1E5363',
      //   colorBgContainer: '#0E1923',
      //   colorBgElevated: '#0E1923',
      //   colorTextBase: '#fff',
      //   colorPrimaryBg: "#64b7d0"
      // }
    }} locale={zhCN}>
      <AntdApp>
        <App />
      </AntdApp>
    </ConfigProvider>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
